import { Box } from '@mui/material';
import React from 'react';

const ProficiecnyExamStack = ({ 
  value=0, 
  label='', 
  subLabel='', 
  backgroundColor='linear-gradient(90deg, #0B0B0B 0%, #2B2A9F 60%, #3533CD 100%)' 
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 120,
        p: '18px',
        borderRadius: '12px',
        background: backgroundColor,
        boxShadow: '0 8px 20px rgba(0,0,0,0.35)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
        <p style={{ color: '#fff', fontSize: 14, fontWeight: 700, margin: 0, lineHeight: '16px' }}>
          {label && <span style={{ display: 'block' }}>{label}</span>}
          {subLabel && <span>{subLabel}</span>}
        </p>
      </Box>

      <p style={{ color: '#fff', fontSize: 42, fontWeight: 900, lineHeight: 1, margin: 0 }}>
        {Number(value)}
      </p>
    </Box>
  );
};

export default ProficiecnyExamStack;

